import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import useContactUtils from '../hooks/useContactUtils';
import ChatMessageContactBtn from './ChatMessageContactBtnStyle';

export type ChatMessageContactRedirectProps = {
  phoneNumber: string;
};

const ChatMessageContactRedirect: React.FC<ChatMessageContactRedirectProps> = ({
  phoneNumber,
}) => {
  const history = useHistory();
  const { formatMessage } = useIntl();
  const { formatContactPhone } = useContactUtils();

  const onRedirectToContact = () => {
    const formatPhoneNumber = formatContactPhone(phoneNumber);
    history.push(`/admin/contact?searchContact=${formatPhoneNumber}`);
  };

  return (
    <ChatMessageContactBtn type="button" onClick={() => onRedirectToContact()}>
      {formatMessage({ id: 'Console.ContactMessage.ShowContact' })}
    </ChatMessageContactBtn>
  );
};

export default ChatMessageContactRedirect;
